import api from 'lib/trpcClient';

export default function useEarliestAvailableLedgerDate(vehicleId: string) {
  const { data: earliestAvailableLedgerDate } =
    api.vehicle.getEarliestLedgerDate.useQuery({ vehicleId });

  return earliestAvailableLedgerDate;
}
